import { compose, withHandlers } from 'coact/recompose'

import View from './ProductsList.jsx'

const ProductsList = compose(
  withHandlers({
    chooseProduct:
      ({ getStocks, setCurSeries }) =>
      product => {
        setCurSeries('')
        getStocks({ products: [product] })
      },
  }),
)(View)

ProductsList.displayName = 'ProductsList'

export default ProductsList
